/* Storing contact us quick answers data */
let qaData;

/* Storing value from name check cookie to variable */
const namecheckStatus = window.Cookies.get('ResultCheck');

/* Variables assigned for tooltip modal functionality */
const infobox = $('.infobox');
const infoboxBtn = $('.infobox-btn');
const closeBtn = $('.infobox__close');

const officeVideo = document.querySelector('video#office--video');
const neverTooLateVideo = document.querySelector('video#never-too-late--video');

if (officeVideo) {
  const _posterBase = 'https://d2h8stzt9pexff.cloudfront.net/assets/live/images/2024/office/';
  if (window.innerWidth >= 1024) {
    officeVideo.poster = _posterBase + 'office--thumbnail.webp?v=2';
  } else if (window.innerWidth >= 768) {
    officeVideo.poster = _posterBase + 'office--thumbnail-768.webp?v=2';
  }
}

const videos = {
  office: { paused: false },
  'never-too-late': { paused: false },
};

/* Cached DOM references */
const $navItems = $('.navigation__item--dropdown');
const $header = $('header');
const $nav = $('nav');
const $body = $('body');

/* Cached scroll targets — populated after DOM ready */
let statItemOffset = null;

/* smooth scroll to item with data-id */
$('.smooth-scroll').each(function () {
  $(this).on('click', function () {
    const loc = $(this).data('link');
    const speed = $(this).data('speed') || 2000;
    scrollTo($(loc), true, speed);
  });
});

/* Smooth scroll for anchor links within resource hub */
$(document).on('click', '.resource-hub__sidebar a[href^="#"]', function (e) {
  const target = $(this.getAttribute('href'));
  if (target.length) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: target.offset().top - 30 }, 2000);
  }
});

let resizeTimeout;

/* Single function to detect mobile device via user agent */
function isMobileDevice() {
  return /Android|BlackBerry|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(navigator.userAgent);
}

const packages = {
  digital: {
    namecheck: '/name-check-digital-package/',
    checkout: '/buy/digital-package/',
  },
  privacy: {
    namecheck: '/name-check-privacy-package/',
    checkout: '/buy/privacy-package/',
  },
  'all-inclusive': {
    namecheck: '/name-check-all-inclusive-package/',
    checkout: '/buy/all-inclusive-package/',
  },
  'all-inclusive-accounting': {
    namecheck: '/name-check-all-inclusive-accounting-package/',
    checkout: '/buy/all-inclusive-accounting-package/',
  },
  'non-residents': {
    namecheck: '/name-check-non-residents-package/',
    checkout: '/buy/non-residents-package/',
  },
  llp: {
    namecheck: '/name-check-llp-package/',
    checkout: '/buy/limited-liability-partnership/',
  },
  'limited-by-guarantee': {
    namecheck: '/name-check-limited-by-guarantee-package/',
    checkout: '/buy/limited-by-guarantee/',
  },
};

/* Function triggers on load */
$(function () {
  logoController();
  burgerNavController();
  navigationController();
  changeNamecheckPlaceholder();
  impactIdentify();
  impactClickId();
  infoboxController();
  meetTeamInfobox();
  selectOrderStep();
  namecheckBanks();
  namecheckFormRouting();
  namecheckSuffixOptions();
  namecheckHideSearch();
  redirectNamecheckPathLinks();
  packageRouting();
  loadEligibleCountryList();
  initHeroVideo();

  /* Cache wonder foundation offset once */
  const $statItem = $('.wonder-foundation-stats__item');
  if ($statItem.length) {
    statItemOffset = $statItem.offset().top;
  }

  if (window.location.pathname.indexOf('/resources/') > -1) {
    initResourceHubStickyTOC();
  }

  /* Fixed: was referencing function instead of calling it */
  if (isPackageTabPage()) {
    showActiveTab();
    showCompanyName();
  }

  if (isCurrentPage('/serviced-offices/') || isCurrentPage('/meeting-rooms/')) {
    checkFormSubmitted();
  }

  if (isCurrentPage('/bizik-answering')) {
    checkFormSubmitted();
    const bizikContactForm = document.querySelector('#bizik-contact-us');
    if (bizikContactForm) {
      bizikContactForm.addEventListener('submit', function (event) {
        event.preventDefault();
        const baseSubmitURL = 'https://api.hsforms.com/submissions/v3/integration/submit';
        const portalId = '144459116';
        const formGuid = '8aca939e-19c7-4319-931f-94392d0a602f';
        const submitURL = `${baseSubmitURL}/${portalId}/${formGuid}`;
        const formData = prepareHubspotFormSubmission(bizikContactForm);
        submitHubspotForm(submitURL, formData);
      });
    }
  }

  if (isCurrentPage('/in-the-press/')) {
    initiateLogoCarousel();
  }

  if (isCurrentPage('/helpful-videos/')) {
    window.MicroModal.init();
  }

  if (isCurrentPage('/business-banking/')) {
    $('#section--banking-cards a.button.button--success').attr('href', 'https://www.1stformations.co.uk/set-up-company/').text('Get Started');
  }

  if (isCurrentPage('/mfa/')) {
    $('.efMfaFormContainer label[for="efemail"]').text('Enter your multi-factor authentication (MFA) code:');
  }

  if (isCurrentPage('/rewards/')) {
    const offerButton = $('.button--reward-offer');
    const offerBox = $('.offer-box');
    const offerCta = $('.offer-cta');
    const currentPartnerPath = window.location.pathname;
    if (offerButton.length > 0) {
      if (!isLoggedIn()) {
        offerButton.attr('href', 'https://www.1stformations.co.uk/login/?re=' + currentPartnerPath);
        offerBox.remove();
        offerCta.show();
      } else {
        $('.page-heading__right .button--reward-offer').remove();
        offerBox.show();
        offerCta.remove();
        offerButton.text('Activate Reward');
      }
    }
  }

  if (isCurrentPage('/accounting-service')) {
    $('.accounting-hero__progress-bar').each(function () {
      const $bar = $(this);
      const $box = $bar.closest('.accounting-hero__box');
      const $fill = $bar.find('.accounting-hero__progress-bar__fill');
      const $count = $bar.closest('.accounting-hero__progress').find('.accounting-hero__progress-count');
      const $items = $box.find('.accounting-hero__item');
      const total = parseInt($bar.data('total'), 10) || $items.length;
      const current = parseInt($bar.data('current'), 10) || 0;
      const spinDuration = 900;
      const gapAfterComplete = 500;
      const boxAnimationDelay = 600;
      const stepDelay = 1500;
      const loopPause = 2000;

      function resetState() {
        $box.removeClass('is-visible');
        $items.removeClass('is-visible');
        $items.find('.accounting-hero__item-icon').removeClass('fa-check').addClass('fa-spinner fa-spin');
        $fill.css('width', '0%');
        $count.text('0 of ' + total);
      }

      function showSpinner(index) {
        $items.eq(index).addClass('is-visible');
      }

      function completeItem(index) {
        $items.eq(index).find('.accounting-hero__item-icon').removeClass('fa-spinner fa-spin').addClass('fa-check');
      }

      function stepTo(step) {
        showSpinner(step - 1);

        setTimeout(function () {
          completeItem(step - 1);

          const percent = Math.round((step / total) * 100);
          $fill.css('width', percent + '%');
          $count.text(step + ' of ' + total);

          if (step < current) {
            setTimeout(function () {
              stepTo(step + 1);
            }, gapAfterComplete);
          } else {
            revealRemaining(current);
          }
        }, spinDuration);
      }

      function revealRemaining(index) {
        if (index >= $items.length) {
          setTimeout(runSequence, loopPause);
          return;
        }
        setTimeout(function () {
          showSpinner(index);
          revealRemaining(index + 1);
        }, gapAfterComplete);
      }

      function runSequence() {
        resetState();

        setTimeout(function () {
          requestAnimationFrame(function () {
            requestAnimationFrame(function () {
              $box.addClass('is-visible');
            });
          });
        }, boxAnimationDelay);

        setTimeout(function () {
          if (current > 0) {
            stepTo(1);
          } else {
            revealRemaining(0);
          }
        }, stepDelay);
      }

      runSequence();
    });
  }

  /* Mobile package tooltip modal */
  const $modal = $('#mobile-package-tooltip-modal');
  if ($modal.length) {
    const $modalContent = $modal.find('.mobile-package-tooltip-modal__content');
    const $modalClose = $modal.find('.mobile-package-tooltip-modal__close');
    const $modalOverlay = $modal.find('.mobile-package-tooltip-modal__overlay');

    function closeTooltipModal() {
      $modal.removeClass('active');
      $body.css('overflow', '');
    }

    $(document).on('click', '.mobile-package-tooltip-btn', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $modalContent.html($(this).find('.mobile-package-tooltip-content').html());
      $modal.addClass('active');
      $body.css('overflow', 'hidden');
    });

    $modalClose.on('click', closeTooltipModal);
    $modalOverlay.on('click', closeTooltipModal);

    $(document).on('keydown', function (e) {
      if (e.key === 'Escape' && $modal.hasClass('active')) closeTooltipModal();
    });
  }

  /* Tab switching for compare packages mobile */
  const $tabs = $('.mobile-package-tabs__tab');
  if ($tabs.length) {
    const $tabContents = $('.compare-package-tab-content');
    $tabs.on('click', function () {
      const selectedTab = $(this).data('tab');
      $tabs.removeClass('active');
      $(this).addClass('active');
      $tabContents.hide();
      $(`[data-tab-content="${selectedTab}"]`).show();
    });
  }

  /* Who's it for: swap active image when a content item is selected */
  const $whosItFor = $('.accounting-whos-it-for');
  if ($whosItFor.length) {
    const $whosItForItems = $whosItFor.find('.accounting-whos-it-for__content ul li');
    const $whosItForImages = $whosItFor.find('.accounting-whos-it-for__images ul li');

    $whosItForItems.on('click', function () {
      const index = $whosItForItems.index(this);
      $whosItForItems.removeClass('active');
      $(this).addClass('active');
      $whosItForImages.removeClass('active').eq(index).addClass('active');
    });
  }

  /* Service plans tab scroll-snap sync (mobile/tablet) */
  $('.service-plans').each(function () {
    const $tabs = $(this).find('.service-plans__tabs li');
    const $plansContainer = $(this).find('.service-plans__plans');
    const $plans = $plansContainer.find('.service-plans__plan');

    function setActiveTab(index) {
      $tabs.removeClass('active').eq(index).addClass('active');
    }

    $tabs.on('click', function () {
      const index = $tabs.index(this);
      const $target = $plans.eq(index);
      if (!$target.length) return;

      setActiveTab(index);
      $target[0].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
    });

    /* Keep the active tab in sync when the user swipes/scrolls the plans manually */
    if ('IntersectionObserver' in window && $plansContainer.length && $plans.length) {
      const observer = new IntersectionObserver(
        (entries) => {
          const mostVisible = entries.filter((entry) => entry.isIntersecting).sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
          if (mostVisible) setActiveTab($plans.index(mostVisible.target));
        },
        { root: $plansContainer[0], threshold: 0.6 },
      );

      $plans.each(function () {
        observer.observe(this);
      });
    }
  });

  $('.service-comparison').each(function () {
    const $table = $(this).find('.service-comparison__table');
    const $spacer = $(this).find('.service-comparison__scroll-spacer');
    const table = $table[0];
    if (!table) return;

    function getPlanColumnStarts() {
      const $cells = $table.find('.service-comparison__row').first().find('.service-comparison__cell');
      if (!$cells.length) return { labelWidth: 0, starts: [] };

      const tableRect = table.getBoundingClientRect();
      const scrollLeft = table.scrollLeft;
      const labelWidth = $cells.first().outerWidth() || 0;
      const starts = $cells
        .slice(1)
        .map(function () {
          return this.getBoundingClientRect().left - tableRect.left + scrollLeft;
        })
        .get();

      return { labelWidth, starts };
    }

    function updateScrollSpacer() {
      if (!$spacer.length) return;
      $spacer.css('width', 0);
      const { labelWidth, starts } = getPlanColumnStarts();
      if (!starts.length) return;

      const target = starts[starts.length - 1] - labelWidth;
      const maxScrollLeft = table.scrollWidth - table.clientWidth;
      const shortfall = target - maxScrollLeft;
      $spacer.css('width', shortfall > 0 ? shortfall + 1 : 0);
    }

    updateScrollSpacer();
    $(window).on('resize', updateScrollSpacer);
  });

  /* Countries popup */
  if (document.getElementById('countriesPopup')) {
    SupportedCountriesModal.init();
  }
});

/* Function triggers on window resize */
$(window).resize(function () {
  navigationController();
  /* Fixed: was assigning a function reference instead of calling setTimeout */
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(function () {
    infoboxController();
    meetTeamInfobox();
  }, 500);
});

/* Function triggers on window orientation change */
$(window).on('orientationchange', function () {
  navigationController();
});

/* Scroll listener */
$(window).scroll(function () {
  if (window.location.pathname === '/') {
    videoPlayPause('office-video', officeVideo, 'office');
    videoPlayPause('never-too-late--video', neverTooLateVideo, 'never-too-late');
  }

  if (window.location.pathname === '/wonder-foundation/' && statItemOffset !== null) {
    const wScroll = $(this).scrollTop();
    if (wScroll > statItemOffset - $(window).height() / 1.2) {
      const $statItem = $('.wonder-foundation-stats__item');
      $statItem.each(function (i) {
        setTimeout(
          () => {
            $statItem.eq(i).addClass('fadeIn');
          },
          300 * (i + 1),
        );
      });
    }
  }
});

/* Detect which logo to use depending on page */
function logoController() {
  $('.header__logo img').attr('src', 'https://d2h8stzt9pexff.cloudfront.net/assets/live/images/1st-formations-logo-retina.png');
}

/* Trigger responsive navigation depending on viewport */
function navigationController() {
  if ($(window).width() <= 1150) {
    mobileNavigation();
  } else {
    desktopNavigation();
  }
}

function mobileNavigation() {
  $navItems.off();
  $navItems.on('click', function (e) {
    if ($(e.target).closest('.navigation__subnav').length === 0) {
      e.preventDefault();
      const currentSubmenu = $(this).children('div');
      hideLastActiveDropDown(currentSubmenu);
      currentSubmenu.toggleClass('navigation__subnav--inactive navigation__subnav--active');
      $(this).toggleClass('active');
    }
  });
  $header.addClass('navigation__nav--mobile');
  $('.header .container').removeClass('container').addClass('container-fluid');
  $('.navigation .container').removeClass('container').addClass('container-fluid');
}

function desktopNavigation() {
  $navItems.off();
  $navItems.on('mouseenter', function () {
    $(this).children('div').removeClass('navigation__subnav--inactive').addClass('navigation__subnav--active');
    $(this).children('a').addClass('active');
  });
  $navItems.on('mouseleave', function () {
    $(this).children('div').addClass('navigation__subnav--inactive').removeClass('navigation__subnav--active');
    $(this).children('a').removeClass('active');
  });
  $header.removeClass('navigation__nav--mobile');
  $nav.removeClass('open');
  $('.header').removeClass('open');
  $body.removeClass('open');
  $('.header .container-fluid').removeClass('container-fluid').addClass('container');
  $('.navigation .container-fluid').removeClass('container-fluid').addClass('container');
}

/* Burger navigation open/close */
function burgerNavController() {
  $(document).mouseup(function (e) {
    const $burger = $('.header__burger');
    const $navigation = $('.navigation__nav');
    if (!$burger.is(e.target) && $burger.has(e.target).length === 0 && !$navigation.is(e.target) && $navigation.has(e.target).length === 0) {
      hideLastActiveDropDown('burger');
      $navigation.removeClass('open');
      $('.header').removeClass('open');
      $body.removeClass('open');
      $('.header__burger .ham').removeClass('active');
      $navItems.removeClass('active');
    }
  });

  $('.header__burger').click(function () {
    const isClosing = $('.navigation__nav').hasClass('open');
    $('.navigation__nav').toggleClass('open');
    $('.header').toggleClass('open');
    $body.toggleClass('open');
    $('.header__burger .ham').toggleClass('active');
    if (isClosing) {
      hideLastActiveDropDown('burger');
      $navItems.removeClass('active');
    }
  });
}

function hideLastActiveDropDown(currentSubmenu) {
  $('.navigation__subnav').each(function () {
    if (currentSubmenu === 'burger' || !currentSubmenu || !$(this).is(currentSubmenu)) {
      $(this).removeClass('navigation__subnav--active').addClass('navigation__subnav--inactive');
    }
  });
  $('.navigation__nav').scrollTop(0);
}

function getViewportWidth() {
  return window.innerWidth || document.documentElement.clientWidth;
}

/* Tooltip: hover on desktop, click modal on mobile */
function infoboxController() {
  const viewportWidth = getViewportWidth();
  infoboxBtn.off();
  if (viewportWidth < 980) {
    infoboxBtn.click(function () {
      $(this).closest('.service-plans__plans').addClass('service-plans__plans--modal-open');
      $(this).parent().parent().find('.infobox').addClass('infobox--active');
    });
    infobox.click(function () {
      $(this).removeClass('infobox--active');
      $('.service-plans__plans--modal-open').removeClass('service-plans__plans--modal-open');
    });
    $('.infobox__content').click(function (e) {
      e.stopPropagation();
    });
  } else {
    infoboxBtn.mouseenter(function () {
      closeBtn.before("<span class='infobox__triangle'></span>");
      $(this).parent().parent().find('.infobox').addClass('infobox--active');
    });
    infoboxBtn.mouseleave(function () {
      $(this).parent().parent().find('.infobox').removeClass('infobox--active');
      $(this).parent().parent().find('.infobox__triangle').remove();
    });
  }
}

function meetTeamInfobox() {
  const $meetBtn = $('.meet-team__circle');
  const viewportWidth = getViewportWidth();
  $meetBtn.off();
  if (viewportWidth < 980) {
    $meetBtn.click(function () {
      $(this).parent().next().addClass('infobox--active');
    });
    infobox.click(function () {
      $(this).removeClass('infobox--active');
    });
    $('.infobox__content').click(function (e) {
      e.stopPropagation();
    });
  } else {
    $meetBtn.mouseenter(function () {
      closeBtn.before("<span class='infobox__triangle'></span>");
      $(this).parent().next().addClass('infobox--active');
    });
    $meetBtn.mouseleave(function () {
      $(this).parent().next().removeClass('infobox--active');
      $(this).parent().next().find('.infobox__triangle').remove();
    });
  }
}

/* Impact identify — send customer email hash if logged in */
async function impactIdentify() {
  try {
    await new Promise((resolve, reject) => {
      const timeout = setTimeout(() => reject(new Error('ire failed to load')), 5000);
      const check = setInterval(() => {
        if (typeof window.ire === 'function') {
          clearInterval(check);
          clearTimeout(timeout);
          resolve();
        }
      }, 50);
    });
    const customerEmail = $('#customer-email').val();
    if (customerEmail && customerEmail !== '##CUSTOMER_EMAIL#') {
      window.ire('identify', {
        customerId: window.sha1(customerEmail),
        customerEmail: window.sha1(customerEmail),
      });
    } else {
      window.ire('identify', { customerId: '', customerEmail: '' });
    }
  } catch (e) {
    console.error('impactIdentify failed:', e);
  }
}

/* Store impact click id in cookie */
function impactClickId() {
  const clickId = new URLSearchParams(window.location.search).get('irclickid');
  if (clickId !== null) window.Cookies.set('clickid', clickId, { expires: 30 });
}

/* Swap the namecheck submit button's label, remembering the original so it can be restored */
function setNamecheckButtonLabel(label) {
  const $button = $('#namecheck-button');
  const $target = $button.find('span').length ? $button.find('span') : $button;
  if ($button.data('originalLabel') === undefined) {
    $button.data('originalLabel', $target.text());
  }
  $target.text(label);
  if ($button.attr('aria-label')) $button.attr('aria-label', label);
}

function resetNamecheckButtonLabel() {
  const $button = $('#namecheck-button');
  const original = $button.data('originalLabel');
  if (original === undefined) return;
  const $target = $button.find('span').length ? $button.find('span') : $button;
  $target.text(original);
  if ($button.attr('aria-label')) $button.attr('aria-label', original);
}

/* Show only the search form inside .hero__namecheck (hiding h1/h2/etc.), visually reordered below the results via CSS order */
function showNamecheckFormOnly() {
  const $namecheck = $('.hero__namecheck');
  $('.hero-accounting__content').addClass('namecheck-reordered');
  $namecheck.show();
  $namecheck.children().not('#home-company-search').hide();
  $namecheck.find('#home-company-search').first().show();
}

/* Restore the full .hero__namecheck content (marketing copy + form) and its original order */
function showNamecheckAll() {
  $('.hero-accounting__content').removeClass('namecheck-reordered');
  $('.hero__namecheck').show().children().show();
}

/* Check company name against eFiling name-check API */
function checkName(name, suffix) {
  const hasSuffix = /\b(ltd|limited|llp)\.?$/i.test(name.trim());
  const companyName = hasSuffix ? name.trim() : `${name} ${suffix}`;
  $.get('https://www.1stformations.co.uk/ejax-name-check', { gle: 'name-check', name: companyName }, function (data) {
    data = JSON.parse(data);
    const { NameStatus: status, NameRequested: requestedName, SensitiveWords: sensitiveWords, MatchName: similarName } = data;
    const namecheck = $('.hero__namecheck');
    const results = $('.namecheck-results');
    let html = '';
    const continueUrl = suffix === 'LLP' ? '/package/llp' : '/compare-packages/';

    $('.namecheck-results__results').removeClass('namecheck-results__results--green namecheck-results__results--amber namecheck-results__results--red');
    $('.hero-accounting__actions').hide();
    showNamecheckAll();
    results.empty().show(1000);

    if (status === 'GREEN') {
      namecheck.hide();
      html += `<div class="namecheck-results__results namecheck-results__results--green">
        <div class="namecheck-results__icon"><i class="fa-duotone fa-circle-check" style="--fa-primary-color: white; --fa-secondary-color: #62a43f; --fa-secondary-opacity: 1.0;"></i></div>
        <h1>${requestedName}</h1>
        <p>Congratulations! Your company name is available. Let's get your business started.</p>
        <div class="namecheck-results__buttons"><a href="${continueUrl}" class="button button--success">Choose a Package</a>
        <a id="reset-namecheck" class="button button--text">Or search again</a></div></div>`;
      setCookie('ResultCheck', 'green');
      checkoutRouting();
    } else if (status === 'AMBER') {
      namecheck.hide();
      const sensitiveWordsList = sensitiveWords.map((w) => w.Word).join(', ');
      html += `<div class="namecheck-results__results namecheck-results__results--amber">
        <div class="namecheck-results__icon"><i class="fa-duotone fa-circle-check" style="--fa-primary-color: white; --fa-secondary-color: #62a43f; --fa-secondary-opacity: 1.0;"></i></div>
        <h1>${requestedName}</h1>
        <p>Please note: The word(s) <strong>${sensitiveWordsList}</strong> is deemed sensitive. You may need to supply additional information to use it.</p>
        <div class="namecheck-results__buttons"><a href="${continueUrl}" class="button button--success">Choose a Package</a>
        <a id="reset-namecheck" class="button button--text">Or search again</a></div></div>`;
      setCookie('ResultCheck', 'green');
      checkoutRouting();
    } else if (status === 'RED') {
      changeNamecheckPlaceholder();
      showNamecheckFormOnly();
      setNamecheckButtonLabel('Search Again');
      html += `<div class="namecheck-results__results namecheck-results__results--red">
        <div class="namecheck-results__icon"><i class="fa-duotone fa-circle-xmark" style="--fa-primary-color: white; --fa-secondary-color: red; --fa-secondary-opacity: 1.0;"></i></div>
        <h1>${requestedName}</h1>
        <p>Sorry, that name's taken - but don't let that stop you. Try a small variation or a new idea below.</p>
      </div>`;
      setCookie('ResultCheck', 'red');
      namecheckRouting();
    } else {
      changeNamecheckPlaceholder();
      showNamecheckFormOnly();
      setNamecheckButtonLabel('Search Again');
      html += `<div class="namecheck-results__results namecheck-results__results--red">
        <div class="namecheck-results__icon"><i class="fa-duotone fa-circle-xmark" style="--fa-primary-color: white; --fa-secondary-color: red; --fa-secondary-opacity: 1.0;"></i></div>
        <h1>${requestedName}</h1>
        <p>Sorry, this company name is unavailable. Also unavailable is: ${similarName}.</p>
      </div>`;
      setCookie('ResultCheck', 'red');
      namecheckRouting();
    }

    results.append(html);

    if (window.innerWidth < 768) {
      $('html, body').animate({ scrollTop: 0 }, 500);
    }
  });
}

function resetNameCheck() {
  changeNamecheckPlaceholder();
  resetNamecheckButtonLabel();
  $('.namecheck-results').empty().hide();
  showNamecheckAll();
  $('.hero-accounting__actions').show();
}

/* Route package buttons based on namecheck cookie */
function packageRouting() {
  const status = (window.Cookies && window.Cookies.get('ResultCheck')) || null;
  if (!status) return;
  if (status === 'green' || status === 'amber') {
    checkoutRouting();
  } else {
    namecheckRouting();
  }
}

function checkoutRouting() {
  $('.button.js-routing').each((_, el) => {
    const pkg = $(el).data('package');
    $(el).attr('href', packages[pkg].checkout);
  });
}

function namecheckRouting() {
  $('.button.js-routing').each((_, el) => {
    const pkg = $(el).data('package');
    $(el).attr('href', packages[pkg].namecheck);
  });
}

/* Utility: get URL parameter */
function getUrlParam(name) {
  const results = new RegExp('[\\?&]' + name + '=([^&#]*)').exec(window.location.href);
  return results ? results[1] || 0 : null;
}

/* Utility: set cookie */
function setCookie(name, value, options = { path: '/' }) {
  window.Cookies.set(name, value, options);
}

/* Utility: get cookie */
function getCookie(name) {
  const value = '; ' + document.cookie;
  const parts = value.split('; ' + name + '=');
  if (parts.length === 2) return parts.pop().split(';').shift();
}

/* Utility: animated scroll to element */
function scrollTo(element, offset = false, speed = 2000) {
  const top = offset ? element.offset().top - 30 : element.offset().top;
  $('html, body').animate({ scrollTop: top }, speed);
}

/* Change namecheck placeholder on mobile */
function changeNamecheckPlaceholder() {
  if ($(window).width() <= 992) {
    $('#company-name').attr('placeholder', 'Enter your company name');
  }
}

/* Utility: detect if element is in viewport */
function isScrolledIntoView(elem) {
  const docViewTop = $(window).scrollTop();
  const docViewBottom = docViewTop + $(window).height();
  const elemTop = $(elem).offset().top;
  const elemBottom = elemTop + $(elem).height();
  return elemBottom <= docViewBottom && elemTop >= docViewTop;
}

/* Utility: detect if logged in */
function isLoggedIn() {
  return $body.hasClass('logged-in') || checkSearchParam('test') || window.location.host === 'new.1stformations.co.uk';
}

/* Utility: check query string param exists */
function checkSearchParam(name) {
  return new URL(window.location.href).searchParams.has(name);
}

/* Detect if current page is a package tab page */
function isPackageTabPage() {
  const pages = ['compare-packages', 'llp', 'limited-by-guarantee', 'eseller', 'plc', 'non-residents'];
  return pages.some((p) => window.location.pathname.indexOf(p) > -1);
}

/* Utility: detect if current page matches path */
function isCurrentPage(page) {
  return window.location.pathname.indexOf(page) > -1;
}

/* Show company name banner if namecheck was green */
function showCompanyName() {
  const hasCompanyName = window.Cookies.get('ResultCheck') === 'green';
  $('.compare-package-namecheck').css('display', hasCompanyName ? 'flex' : 'none');
}

/* Set active tab on compare packages */
function showActiveTab() {
  const page = window.location.pathname;
  const $tabs = $('.compare-package-tabs__tabs li');
  $tabs.removeClass('active');
  if (page.indexOf('package/non-residents') > -1) $tabs.filter('[data-tab="non-residents"]').addClass('active');
  else if (page.indexOf('package/eseller') > -1) $tabs.filter('[data-tab="eseller"]').addClass('active');
  else if (page.indexOf('package/llp') > -1) $tabs.filter('[data-tab="llp"]').addClass('active');
  else if (page.indexOf('package/limited-by-guarantee') > -1) $tabs.filter('[data-tab="guarantee"]').addClass('active');
  else if (page.indexOf('package/plc') > -1) $tabs.filter('[data-tab="plc"]').addClass('active');
  else if (page === '/compare-packages/') $tabs.filter('[data-tab="limited-company"]').addClass('active');
}

function changeFAQContents(data) {
  const html = data
    .map(
      (item) =>
        `<div class="quick-answers__faq">
      <h4 class="quick-answers__question">${item.question}</h4>
      <div class="quick-answers__answer">${item.answer}</div>
    </div>`,
    )
    .join('');
  $('#faq-questions').empty().append(html);
}

/* Show thank you message if form was submitted */
function checkFormSubmitted() {
  const actionParam = new URLSearchParams(window.location.search).get('action');
  if (actionParam === 'submitted') {
    $('#contact-us-thankyou').show();
    $('html, body').animate({ scrollTop: $('#contact-us-thankyou').offset().top }, 2000);
  } else {
    $('#contact-us-thankyou').hide();
  }
}

function selectOrderStep() {
  if (!hasOrderSteps()) return;
  const page = window.location.pathname;
  let currentStep = 4;
  if (page.indexOf('/name-check/') > -1) currentStep = 1;
  else if (page.indexOf('/package/') > -1 || page.indexOf('/compare-packages/') > -1) currentStep = 2;
  else if (page.indexOf('/buy/') > -1) currentStep = 3;

  $(`.order-steps__step[data-step="${currentStep}"]`).addClass('current');
  [...Array(currentStep).keys()].forEach((step) => $(`.order-steps__step[data-step="${step}"]`).addClass('active'));
}

function hasOrderSteps() {
  return $('.order-steps').length > 0;
}

function isNameCheckPage() {
  return window.location.pathname.indexOf('/name-check/') > -1;
}

/* Send "namecheckpath" visitors on package landing pages straight to checkout */
function redirectNamecheckPathLinks() {
  const action = window.location.hash.substring(1) || getUrlParam('action');
  if (action !== 'namecheckpath') return;

  const pkg = Object.keys(packages).find((key) => isCurrentPage(`package/${key}`));
  if (pkg) {
    $('a[href^="/name-check-"]').attr('href', packages[pkg].checkout);
  }
}

/* Route namecheck form action based on package */
function namecheckFormRouting() {
  if (!isNameCheckPage()) return;
  const action = window.location.hash.substring(1) || getUrlParam('action');
  console.log('namecheck package:', action || null);
  if (action === 'namecheckpath') {
    $('a:contains("Continue")').attr('href', '/compare-packages/#namecheckpath');
    $('form[action^="/name-check/"]').attr('action', '/name-check/#namecheckpath');
  } else if (action && packages[action]) {
    $('a:contains("Continue")').attr('href', packages[action].checkout);
    $('form[action^="/name-check/"]').attr('action', `/name-check/#${action}`);
    $('input[name="action"]').attr('value', action);
  } else if (action) {
    console.warn('namecheck: unrecognised package action, sending to compare-packages:', action);
    $('a:contains("Continue")').attr('href', '/compare-packages/');
  }
}

/* Hide the name search box once a valid package has been selected */
function namecheckHideSearch() {
  if (!isNameCheckPage()) return;
  const action = window.location.hash.substring(1) || getUrlParam('action');
  if (action === 'namecheckpath' || (action && packages[action])) {
    $('.namecheck-form__search').hide();
  }
}

/* Restrict the company suffix options to what's valid for the chosen package */
function namecheckSuffixOptions() {
  if (!isNameCheckPage()) return;
  const action = window.location.hash.substring(1) || getUrlParam('action');
  const isLLP = action === 'llp';

  $('select[name="company-suffix"]').each(function () {
    const $select = $(this);
    $select.find('option').each(function () {
      if (($(this).val() === 'LLP') !== isLLP) $(this).remove();
    });
    $select.toggleClass('no-arrow', isLLP).prop('disabled', isLLP);
  });
}

/* Show the bank ads relevant to the package the visitor came from */
function namecheckBanks() {
  if (!isNameCheckPage()) return;
  const action = window.location.hash.substring(1) || getUrlParam('action');

  if (action === 'limited-by-guarantee') {
    $('.bank-ads--default, .bank-ads--other').hide();
  } else if (action === 'non-residents') {
    $('.bank-ads--default').hide();
  } else {
    $('.bank-ads--other').hide();
  }
}

function checkInput(form) {
  const $scope = form ? $(form) : $(document);
  const $name = $scope.find('#company_name');
  const requestedName = $.trim($name.val());
  const letters = requestedName.replace(/[^a-zA-Z]/g, '');
  if (letters.length < 3) return false;

  const suffix = $scope.find('#company-suffix').val();
  const hasSuffix = /\b(ltd|limited|llp)\.?$/i.test(requestedName);
  if (suffix && !hasSuffix) $name.val(`${requestedName} ${suffix}`);

  return true;
}

window.checkInput = checkInput;

/* Duplicate items in logo carousel for infinite scroll effect */
function initiateLogoCarousel() {
  document.querySelectorAll('.scroller').forEach((scroller) => {
    const inner = scroller.querySelector('.scroller__inner');
    Array.from(inner.children).forEach((item) => {
      const clone = item.cloneNode(true);
      clone.setAttribute('aria-hidden', true);
      inner.appendChild(clone);
    });
  });
}

/* POST JSON to endpoint */
async function postData(url = '', data = {}) {
  const response = await fetch(url, {
    method: 'POST',
    mode: 'cors',
    cache: 'no-cache',
    credentials: 'same-origin',
    headers: { 'Content-Type': 'application/json' },
    redirect: 'follow',
    referrerPolicy: 'no-referrer',
    body: JSON.stringify(data),
  });
  return response.json();
}

/* Serialise form fields to array of {name, value} */
function formFieldsToJSON(form) {
  return Array.from(new FormData(form)).map(([name, value]) => ({ name, value }));
}

function buildHubspotContext() {
  return {
    hutk: getCookie('hubspotutk'),
    pageUri: window.location.href,
    pageName: document.title,
  };
}

function prepareHubspotFormSubmission(form) {
  return {
    submittedAt: Date.now(),
    fields: formFieldsToJSON(form),
    context: buildHubspotContext(),
  };
}

function submitHubspotForm(hsFormURL, data) {
  postData(hsFormURL, data).then((data) => {
    if (data.inlineMessage) window.location.href = '/bizik-answering/?action=submitted';
  });
}

function isEmulation() {
  return $('#efEmulationWidget').length > 0;
}

function loadEligibleCountryList() {
  if (!$('#eligible-countries-list').length) return;
  $.ajax({
    url: 'https://dev.1stformations.co.uk/items/eligible_countries',
    method: 'GET',
    dataType: 'json',
    success: function (json) {
      $('#eligible-countries-list p small').text(`Last Updated: ${json.data.last_updated}`);
      const items = json.data.countries.map((c) => `<li>${c}</li>`).join('');
      $('#eligible-countries-list ul.home-non-residents__list').append(items);
    },
    error: function (xhr, status, error) {
      console.error('Error:', error);
    },
  });
}

function deslugify(slug) {
  return slug
    .replace(/-/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/\b\w/g, (char) => char.toUpperCase());
}

function isValidPackage(packageName) {
  return Object.prototype.hasOwnProperty.call(packages, packageName);
}

window.loadEligibleCountryList = loadEligibleCountryList;

/* CTA close button */
$body.on('click', '.hero-cta__close', function () {
  setCookie('ctahide', true, { path: '/' });
  $('.hero-cta').slideUp().removeClass('hero-cta--fixed');
  $('.hero__main').removeClass('hero__main--ctafixed');
});

/* Formation video scroll-to-top on click */
$('#video-feature').on('click', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: $($.attr(this, 'href')).position().top }, 2500);
});

/* Hero video — honour reduced-motion by holding on the poster frame instead of
   looping. Only runs when the hero media is set to video. */
function initHeroVideo() {
  const video = document.querySelector('video.hero-accounting__media-el');
  if (!video) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    video.removeAttribute('autoplay');
    video.pause();
  }
}

/* Namecheck form submit */
$('#namecheck-button').on('click', function (event) {
  event.preventDefault();
  const requestedName = $('#company-name').val();
  const companySuffix = $('#company-suffix').val() || 'Ltd';
  const emptyValues = ['', 'Enter your company name...', 'Enter your company name to check if it is available', 'eg. The CoffeeBean Ltd'];
  if (!requestedName || emptyValues.includes(requestedName)) return false;
  $('#company-name').val('').blur();
  checkName(requestedName, companySuffix);
});

/* Namecheck reset */
$body.on('click', '#reset-namecheck', resetNameCheck);

/* ------------------------------------------------------------------ */
/* Consolidated FAQ / accordion handlers                               */
/* ------------------------------------------------------------------ */

/* Generic toggleFAQ used by multiple accordion types */
function toggleFAQ($faq, answerClass, iconClass) {
  const $answer = $faq.find(`.${answerClass}`);
  const $icon = $faq.find(`.${iconClass}`);

  if ($answer.css('display') === 'none') {
    $(`.${answerClass}`).slideUp('fast');
    $(`.${iconClass} .fa-angle-down`).hide();
    $(`.${iconClass} .fa-angle-right`).show();
    $faq.siblings().removeClass('active');
    $answer.slideDown();
    $icon.find('.fa-angle-right').hide();
    $icon.find('.fa-angle-down').show();
    $faq.addClass('active');
  } else {
    $answer.slideUp();
    $icon.find('.fa-angle-down').hide();
    $icon.find('.fa-angle-right').show();
    $faq.removeClass('active');
  }
}

/* Map of selector → [answerClass, iconClass] for icon-based accordions */
const faqMap = {
  '.office-faqs__faq': ['office-faqs__answer', 'office-faqs__icon'],
  '.faqs-large__faq': ['faqs-large__answer', 'faqs-large__icon'],
  '.meeting-rooms-faqs__faq': ['meeting-rooms-faqs__answer', 'meeting-rooms-faqs__icon'],
  '.home-faqs__faq': ['home-faqs__answer', 'home-faqs__icon'],
};

Object.entries(faqMap).forEach(([selector, [answerClass, iconClass]]) => {
  $(selector).on('click', function () {
    toggleFAQ($(this), answerClass, iconClass);
  });
});

/* faqs-large: "Show X more questions" / "Show fewer questions" toggle for the FAQs (and category headings) marked hidden */
$('.faqs-large__more').on('click', function () {
  const $button = $(this);
  const expand = $button.attr('aria-expanded') !== 'true';
  const $extra = $button.closest('.faqs-large').find('.faqs-large__faq--hidden, .faqs-large__category--hidden');

  // Slides like a single answer; jQuery's inline display overrides the --hidden classes, which stay as the marker
  $extra.stop(true, true)[expand ? 'slideDown' : 'slideUp']();
  $button.attr('aria-expanded', String(expand));
  $button.find('.faqs-large__more-label').toggle();
  $button.find('.fa-angle-down').toggle(!expand);
  $button.find('.fa-angle-up').toggle(expand);
});

/* Standard slide-toggle accordions (no icon state) */
function toggleSlideAccordion($item, answerSel, questionIconSel) {
  const $answer = $item.find(answerSel);
  const isHidden = $answer.css('display') === 'none';
  $(answerSel).slideUp('fast');
  $(`${questionIconSel} svg:first-child`).show();
  $(`${questionIconSel} svg:last-child`).hide();
  if (isHidden) {
    $answer.slideDown();
    $item.find(`${questionIconSel} svg:first-child`).hide();
    $item.find(`${questionIconSel} svg:last-child`).show();
  }
}

$('.accordion-faqs__faq').on('click', function () {
  toggleSlideAccordion($(this), '.accordion-faqs__answer', '.accordion-faqs__question span');
});

$('.accordion-list__item').on('click', function () {
  toggleSlideAccordion($(this), '.accordion-list__content', '.accordion-list__heading span');
});

/* Collapsible sections */
$('.collapsible__header').on('click', function () {
  $('.collapsible__content').slideUp();
  $('.collapsible__icons .fa-angle-down').hide();
  $('.collapsible__icons .fa-angle-right').show();
  const $current = $(this).parent();
  if ($current.find('.collapsible__content').css('display') === 'none') {
    $current.find('.collapsible__content').slideDown();
    $current.find('.collapsible__icons .fa-angle-right').hide();
    $current.find('.collapsible__icons .fa-angle-down').show();
  } else {
    $current.find('.collapsible__content').slideUp();
    $current.find('.collapsible__icons .fa-angle-down').hide();
    $current.find('.collapsible__icons .fa-angle-right').show();
  }
});

/* Service comparison table: sticky plan header + sticky category bands.
   Native position:sticky doesn't work here - the shared .page wrapper
   (overflow:hidden) and our own horizontally-scrolling __table
   (overflow-x:auto) both count as the "nearest scrolling ancestor", and
   neither actually scrolls vertically itself, so sticky never engages.
   This drives position:fixed manually instead, via each row's -wrap
   element, which stays in normal flow to reserve the vacated space and
   mask the fixed element back down to the table's visible width. */
(function () {
  const $tables = $('.service-comparison__table');
  if (!$tables.length) return;

  // Measure where the site nav actually renders right now, rather than
  // trusting its declared CSS position - it's only genuinely stuck for part
  // of the page's scroll range, not for its whole "position: sticky" span.
  function getSiteHeaderOffset() {
    const siteHeader = $('.sticky-header')[0];
    return siteHeader ? Math.max(0, siteHeader.getBoundingClientRect().bottom) : 0;
  }

  // topOffset: distance from the viewport top this element should stick to.
  // releaseBottom: once this drops above (topOffset + the element's own
  // height), the element has scrolled past its own container and must let go.
  // Returns whether it ended up stuck, so callers can stack the next element
  // underneath it.
  function stickElement($wrap, $el, topOffset, releaseBottom, tableRect, scrollLeft) {
    const wrapTop = $wrap[0].getBoundingClientRect().top;
    const elHeight = $el.outerHeight();
    const shouldStick = wrapTop < topOffset && releaseBottom > topOffset + elHeight;

    if (shouldStick) {
      // Once fixed, width:auto no longer means "fill the table" - it shrinks
      // to fit content instead, so the grid collapses to its bare min-width.
      // Pin it back to whatever width it would naturally render at in flow.
      const minWidthPx = parseFloat(getComputedStyle($el[0]).minWidth) || 0;
      const naturalWidth = Math.max(tableRect.width, minWidthPx);

      $wrap.css({ height: elHeight, width: tableRect.width, minWidth: 0 });
      $el.addClass('is-stuck').css({
        top: topOffset,
        left: tableRect.left,
        width: naturalWidth,
        transform: `translateX(${-scrollLeft}px)`,
      });
    } else {
      $wrap.css({ height: '', width: '', minWidth: '' });
      $el.removeClass('is-stuck').css({ top: '', left: '', width: '', transform: '' });
    }

    return shouldStick;
  }

  function pinAnchor($el, selector, scrollLeft) {
    $el.find(selector).css('transform', `translateX(${scrollLeft}px)`);
  }

  function updateRibbon($table, tableRect) {
    const ribbon = document.querySelector('.service-comparison__ribbon');
    const headCell = $table[0].querySelector('.service-comparison__headcell--highlight');
    const dataCells = $table[0].querySelectorAll('.service-comparison__row .service-comparison__cell--highlight');
    const dataCell = Array.from(dataCells).find((cell) => cell.offsetParent !== null);
    if (!ribbon || !headCell || !dataCell) return;

    const headRect = headCell.getBoundingClientRect();
    const cellRect = dataCell.getBoundingClientRect();
    const left = Math.max(cellRect.left, tableRect.left);
    const right = Math.min(cellRect.right, tableRect.right);

    ribbon.style.top = `${headRect.top - ribbon.offsetHeight}px`;
    ribbon.style.left = `${left}px`;
    ribbon.style.width = `${Math.max(0, right - left)}px`;

    // Add 'stuck' class when the head is stuck
    const $head = $table.find('.service-comparison__head');
    if ($head.hasClass('is-stuck')) {
      ribbon.classList.add('stuck');
    } else {
      ribbon.classList.remove('stuck');
    }
  }

  function updateStickyTable($table) {
    const table = $table[0];
    const tableRect = table.getBoundingClientRect();
    const scrollLeft = table.scrollLeft;
    const stickyOffset = getSiteHeaderOffset();

    const borderLeft = parseFloat(getComputedStyle(table).borderLeftWidth) || 0;
    const borderRight = parseFloat(getComputedStyle(table).borderRightWidth) || 0;
    const contentBox = { left: tableRect.left + borderLeft, width: tableRect.width - borderLeft - borderRight };

    const ribbon = document.querySelector('.service-comparison__ribbon');
    const ribbonHeight = ribbon ? ribbon.offsetHeight : 0;
    const headTopOffset = stickyOffset + ribbonHeight;

    const $headWrap = $table.children('.service-comparison__head-wrap');
    const $head = $headWrap.children('.service-comparison__head');
    stickElement($headWrap, $head, headTopOffset, tableRect.bottom, contentBox, scrollLeft);
    pinAnchor($head, '.service-comparison__headcell:first-child', scrollLeft);
    updateRibbon($table, tableRect);

    let cumulativeOffset = headTopOffset + ($headWrap.outerHeight() || 0);

    $table.children('.service-comparison__section').each(function () {
      const $section = $(this);
      const $rows = $section.children('.service-comparison__rows');
      const isCollapsed = $rows.css('display') === 'none';
      const releaseBoundary = isCollapsed ? tableRect.bottom : this.getBoundingClientRect().bottom;

      const $bandWrap = $section.children('.service-comparison__band-wrap');
      const $band = $bandWrap.children('.service-comparison__band');
      const stuck = stickElement($bandWrap, $band, cumulativeOffset, releaseBoundary, contentBox, scrollLeft);
      pinAnchor($band, '.service-comparison__band-title', scrollLeft);

      if (stuck) {
        cumulativeOffset += $bandWrap.outerHeight() || 0;
      }
    });
  }

  let ticking = false;
  function requestStickyUpdate() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(() => {
      $tables.each(function () {
        updateStickyTable($(this));
      });
      ticking = false;
    });
  }

  $(window).on('scroll resize load', requestStickyUpdate);
  $tables.on('scroll', requestStickyUpdate);
  requestStickyUpdate();

  $('.service-comparison__band').on('click', function () {
    const $section = $(this).closest('.service-comparison__section');
    $section.find('.service-comparison__rows').slideToggle('fast', requestStickyUpdate);
    $(this).find('.service-comparison__chevron .fa-chevron-up, .service-comparison__chevron .fa-chevron-down').toggle();
  });
})();

/* Smooth scroll to a comparison table band, landing it just below the
   stuck plan header so its first rows aren't hidden underneath. Measures
   the band's -wrap rather than the band itself, since the band may be
   position:fixed (is-stuck) at the time of the click. */
function scrollToComparisonBand(selector, speed = 1000) {
  const $band = $(selector);
  if (!$band.length) return;

  const $table = $band.closest('.service-comparison__table');
  const $section = $band.closest('.service-comparison__section');
  const $bandWrap = $band.parent('.service-comparison__band-wrap');
  const $rows = $section.children('.service-comparison__rows');

  // Open the section first if it's collapsed, otherwise there's nothing to show
  if ($rows.css('display') === 'none') {
    $rows.show();
    $band.find('.service-comparison__chevron .fa-chevron-up, .service-comparison__chevron .fa-chevron-down').toggle();
  }

  // The site nav is only stuck at mobile/tablet widths (relative on desktop)
  const siteHeader = $('.sticky-header')[0];
  const headerPosition = siteHeader ? getComputedStyle(siteHeader).position : '';
  const siteHeaderHeight = headerPosition === 'sticky' || headerPosition === 'fixed' ? siteHeader.offsetHeight : 0;

  const ribbonHeight = $table.find('.service-comparison__ribbon').outerHeight() || 0;
  const headHeight = $table.children('.service-comparison__head-wrap').outerHeight() || 0;

  const top = $bandWrap.offset().top - siteHeaderHeight - ribbonHeight - headHeight;
  $('html, body').animate({ scrollTop: top }, speed);
}

$('#xero-quick-jump').on('click', function () {
  scrollToComparisonBand('#xero-accounting-software-plans');
});

/* Quick answers category dropdown */
$('.quick-answers__category').on('click', function () {
  const $dropdown = $(this).next();
  const isExpanded = $dropdown.hasClass('quick-answers__dropdown--active');
  $dropdown.toggleClass('quick-answers__dropdown--active', !isExpanded);
  $(this).find('.fa-angle-right').toggle(isExpanded);
  $(this).find('.fa-angle-down').toggle(!isExpanded);
});

$(document).on('click', '#quick-answers-dropdown a', function (e) {
  e.preventDefault();
  const $li = $(this).closest('li');
  const subject = $(this).text().trim();
  const targetSlug = $li.data('target') || subject.toLowerCase().replace(/ /g, '_');
  const $container = $li.closest('.quick-answers');

  $container.find('.quick-answers__dropdown').removeClass('quick-answers__dropdown--active');
  $container.find('#quick-answers-dropdown li.active').removeClass('active');
  $li.addClass('active');

  const $groups = $container.find('#faq-questions > .quick-answers__faqs');
  $groups.hide().filter(`[data-category="${targetSlug}"]`).show();
  $container.find('.quick-answers__category h4').text(subject);
});

$body.on('click', '.quick-answers__question', function () {
  const $answer = $(this).next();
  const isExpanded = $answer.hasClass('quick-answers__answer--active');
  $('.quick-answers__answer').removeClass('quick-answers__answer--active');
  if (!isExpanded) $answer.addClass('quick-answers__answer--active');
});

$('#study-read-more').on('click', function () {
  $(this).addClass('hidden');
  $('#study-more-text').removeClass('hidden').addClass('block');
});

$('.video-transcript__readMore').click(function () {
  const $moreText = $('.video-transcript__moreText');
  const $btn = $(this);
  if ($moreText.is(':hidden')) {
    $moreText.slideDown('slow', function () {
      $btn.text('Show Less');
    });
  } else {
    $moreText.slideUp('slow', function () {
      $btn.text('Read More');
    });
  }
});

$('.mobile-package-boxes__more-button').on('click', function () {
  if (isPackageTabPage()) $(this).parent().next().toggle('slow');
});

$('.helpful-videos__category').on('click', function () {
  $('.helpful-videos__category').removeClass('selected');
  $(this).addClass('selected');
  $('html, body').animate({ scrollTop: $('#videos--' + $(this).data('category')).offset().top - 30 }, 2000);
});

$('.case-studies__category').on('click', function () {
  const selectedCategory = $(this).attr('data-industry');
  $('.case-studies__category').removeClass('current');
  $(this).addClass('current');
  if (selectedCategory === 'all') {
    $('.case-studies__study').removeClass('hide').addClass('show');
    $('.case-studies-banner, .case-studies-quote, .case-studies-partner-banner').show();
  } else {
    $('.case-studies__study').removeClass('show').addClass('hide');
    $(`.case-studies__study[data-industry="${selectedCategory}"]`).removeClass('hide').addClass('show');
    $('.case-studies-banner, .case-studies-quote, .case-studies-partner-banner').hide();
  }
});

$('.partnerships__categories--desktop .partnerships__category').on('click', function () {
  scrollTo($('#partnerships-category--' + $(this).data('category')), true, 2000);
});

$('.scroll-btn[data-target]').on('click', function (e) {
  e.preventDefault();
  scrollTo($($(this).data('target')), true, 2000);
});

$('.partnerships__categories--mobile select').on('change', function () {
  $(this).blur();
  scrollTo($('#partnerships-category--' + $(this).val()), true, 2000);
});

$('.reward-partners__categories--desktop .reward-partners__category').on('click', function () {
  const category = $(this).data('category');
  $('.reward-partners__category').removeClass('current');
  $(this).addClass('current');
  if (category === 'all') {
    $('.reward-partners__partner').removeClass('hide').addClass('show');
  } else {
    $('.reward-partners__partner').removeClass('show').addClass('hide');
    $(`.reward-partners__partner[data-category="${category}"]`).removeClass('hide').addClass('show');
  }
});

$('.reward-partners__categories--mobile select').on('change', function () {
  const category = $(this).val();
  $(this).blur();
  if (category === 'all') {
    $('.reward-partners__partner').removeClass('hide').addClass('show');
  } else {
    $('.reward-partners__partner').removeClass('show').addClass('hide');
    $(`.reward-partners__partner[data-category="${category}"]`).removeClass('hide').addClass('show');
  }
});

$('.so-contact-button').on('click', function () {
  scrollTo($('#section--serviced-office-contact-us'), false, 2000);
});

$('.mr-explore-rooms').on('click', function () {
  scrollTo($('#section--meeting-rooms-book-room'), true, 2000);
});

$('.mr-contact-button').on('click', function () {
  scrollTo($('#section--meeting-rooms-contact-us'), true, 2000);
});

$('#open-hubspot').on('click', function (event) {
  event.preventDefault();
  if (window.HubSpotConversations && window.HubSpotConversations.widget) {
    window.HubSpotConversations.widget.open();
  } else {
    console.error('HubSpot Conversations widget not loaded yet.');
  }
});

/* Scroll to top — merged duplicate selectors */
$('#scroll-top, .scroll-top, .js-scroll-top').on('click', function (e) {
  e.preventDefault();
  $('html, body').animate({ scrollTop: 0 }, 500);
});

/* Scroll to categories button on helpful videos page */
$('.scroll-to-categories').on('click', function () {
  $('html, body').animate({ scrollTop: $('.helpful-videos__categories').offset().top - 100 }, 500);
});

$(window).on('scroll', function () {
  if (!$('.scroll-to-categories').length) return;
  const scrollPosition = $(window).scrollTop();
  const categoriesPosition = $('.helpful-videos__categories').offset().top;
  const footerPosition = $('footer').offset().top;
  const windowHeight = $(window).height();
  const visible = scrollPosition > categoriesPosition + 300 && scrollPosition + windowHeight < footerPosition;
  $('.scroll-to-categories').toggleClass('visible', visible);
});

$('#show-more-team').on('click', function (e) {
  e.preventDefault();
  $('.our-people__additional').show();
  $(this).hide();
});

$('.featured-video__video .helpful-videos__thumbnail').on('click touchstart', function () {
  window.MicroModal.show('featured-video-modal');
  const $iframe = $('iframe#vimeo-iframe-video');
  $iframe.attr('src', $iframe.attr('src').replace('autoplay=0', 'autoplay=1'));
});

function videoPlayPause(elementID, player, key) {
  if (!player) return;
  if ($('#' + elementID).isOnScreen()) {
    if (player.preload === 'none') {
      player.preload = 'auto';
      player.load();
    }
    if (!videos[key].paused) player.play();
  } else {
    player.pause();
  }
}

if (window.location.pathname === '/') {
  officeVideo.onpause = function () {
    if ($('#office-video').isOnScreen()) videos.office.paused = true;
  };
  officeVideo.onplay = function () {
    videos.office.paused = false;
  };

  neverTooLateVideo.onpause = function () {
    if ($('#never-too-late--video').isOnScreen()) videos['never-too-late'].paused = true;
  };
  neverTooLateVideo.onplay = function () {
    videos['never-too-late'].paused = false;
  };
}

$.fn.isOnScreen = function () {
  const win = $(window);
  const viewport = {
    top: win.scrollTop(),
    left: win.scrollLeft(),
    right: win.scrollLeft() + win.width(),
    bottom: win.scrollTop() + win.height(),
  };
  const bounds = {
    left: this.offset().left,
    top: this.offset().top,
    right: this.offset().left + this.outerWidth(),
    bottom: this.offset().top + this.outerHeight(),
  };
  return !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
};

function initResourceHubStickyTOC() {
  const sidebar = document.querySelector('.resource-hub__sidebar');
  const section = document.querySelector('.resource-hub-sticky');
  const tocLinks = sidebar ? sidebar.querySelectorAll('.table-of-contents a[href^="#"]') : [];
  if (!sidebar || !section) return;

  let sidebarTop = 0;
  let sidebarLeft = 0;
  let sidebarWidth = 0;
  let sectionTop = 0;
  let sectionBottom = 0;
  let isSticky = false;

  const STICKY_THRESHOLD = 24;
  const ACTIVE_OFFSET = 120;
  const MOBILE_BREAKPOINT = 768;
  const RESIZE_DELAY = 150;
  const INIT_DELAY = 100;

  const headings = Array.from(tocLinks)
    .map((link) => {
      const id = link.getAttribute('href').substring(1);
      const element = document.getElementById(id);
      return element ? { id, element, link, li: link.closest('li') } : null;
    })
    .filter(Boolean);

  const getScrollTop = () => window.pageYOffset || document.documentElement.scrollTop;
  const isMobileWidth = () => window.innerWidth < MOBILE_BREAKPOINT;

  const updateSectionBoundaries = (sectionRect, scrollTop) => {
    const currentTop = sectionRect.top + scrollTop;
    const currentBottom = sectionRect.bottom + scrollTop;
    if (sectionTop === 0 || Math.abs(currentTop - sectionTop) > 50) sectionTop = currentTop;
    if (sectionBottom === 0 || Math.abs(currentBottom - sectionBottom) > 50) sectionBottom = currentBottom;
  };

  const calculateSidebarPosition = (container, rect) => {
    if (container && !isMobileWidth()) {
      const containerRect = container.getBoundingClientRect();
      const gap = parseFloat(window.getComputedStyle(container).gap) || parseFloat(window.getComputedStyle(container).columnGap) || 48;
      const availableWidth = containerRect.width - gap;
      return { left: containerRect.left + (availableWidth * 3) / 4 + gap, width: availableWidth / 4 };
    }
    return { left: sidebarLeft || rect.left, width: sidebarWidth || rect.width };
  };

  const setStickyStyles = (el, top, left, width) => {
    el.style.setProperty('position', 'fixed', 'important');
    el.style.setProperty('top', top + 'px', 'important');
    el.style.setProperty('left', left + 'px', 'important');
    el.style.setProperty('width', width + 'px', 'important');
    el.style.setProperty('max-height', 'calc(100vh - 3rem)', 'important');
    el.style.setProperty('overflow-y', 'auto', 'important');
  };

  const removeStickyStyles = (el) => {
    ['position', 'top', 'left', 'width', 'max-height', 'overflow-y'].forEach((p) => el.style.removeProperty(p));
  };

  const updateActiveSection = () => {
    if (!headings.length) return;
    const scrollTop = getScrollTop();
    let activeHeading = null;
    for (let i = headings.length - 1; i >= 0; i--) {
      if (scrollTop + ACTIVE_OFFSET >= scrollTop + headings[i].element.getBoundingClientRect().top) {
        activeHeading = headings[i];
        break;
      }
    }
    headings.forEach((h) => {
      const isActive = h === activeHeading || (!activeHeading && h === headings[0]);
      h.li.classList.toggle('is-active', isActive);
      h.link.classList.toggle('is-active', isActive);
    });
  };

  const updateSticky = () => {
    if (isMobileWidth()) {
      if (isSticky) {
        removeStickyStyles(sidebar);
        sidebar.classList.remove('resource-hub__sidebar--sticky');
        isSticky = false;
        sidebarTop = sectionBottom = 0;
      }
      return;
    }

    const rect = sidebar.getBoundingClientRect();
    const sectionRect = section.getBoundingClientRect();
    const scrollTop = getScrollTop();
    const sidebarHeight = sidebar.offsetHeight;

    if (sidebarTop === 0 && rect.top > 0 && !isSticky) {
      sidebarTop = rect.top + scrollTop;
      sidebarLeft = rect.left;
      sidebarWidth = rect.width;
      sectionTop = sectionRect.top + scrollTop;
      sectionBottom = sectionRect.bottom + scrollTop;
    }

    updateSectionBoundaries(sectionRect, scrollTop);

    const maxStickyScroll = sectionBottom - sidebarHeight - STICKY_THRESHOLD;
    const isWithinSection = scrollTop >= sectionTop && scrollTop < sectionBottom && sectionRect.bottom > 0;

    if (!isWithinSection) {
      if (isSticky) {
        sidebarLeft = sidebar.getBoundingClientRect().left;
        sidebarWidth = sidebar.getBoundingClientRect().width;
        removeStickyStyles(sidebar);
        sidebar.classList.remove('resource-hub__sidebar--sticky');
        isSticky = false;
      }
      return;
    }

    const container = sidebar.closest('.resource-hub__container');
    const position = calculateSidebarPosition(container, rect);
    const shouldStickAtBottom = scrollTop >= maxStickyScroll;
    const shouldStickAtTop = scrollTop + STICKY_THRESHOLD > sidebarTop && sidebarTop > 0 && scrollTop < maxStickyScroll;
    const shouldUnstick = scrollTop + STICKY_THRESHOLD <= sidebarTop;

    if (shouldStickAtBottom) {
      const finalTop = sectionRect.bottom - sidebarHeight;
      if (!isSticky) {
        setStickyStyles(sidebar, finalTop, position.left, position.width);
        sidebar.classList.add('resource-hub__sidebar--sticky');
        isSticky = true;
      } else {
        sidebar.style.setProperty('top', finalTop + 'px', 'important');
        sidebar.style.setProperty('left', position.left + 'px', 'important');
        sidebar.style.setProperty('width', position.width + 'px', 'important');
      }
    } else if (shouldStickAtTop) {
      if (!isSticky) {
        setStickyStyles(sidebar, STICKY_THRESHOLD, position.left, position.width);
        sidebar.classList.add('resource-hub__sidebar--sticky');
        isSticky = true;
      } else {
        sidebar.style.setProperty('top', STICKY_THRESHOLD + 'px', 'important');
        sidebar.style.setProperty('left', position.left + 'px', 'important');
        sidebar.style.setProperty('width', position.width + 'px', 'important');
      }
    } else if (isSticky && shouldUnstick) {
      sidebarLeft = sidebar.getBoundingClientRect().left;
      sidebarWidth = sidebar.getBoundingClientRect().width;
      removeStickyStyles(sidebar);
      sidebar.classList.remove('resource-hub__sidebar--sticky');
      isSticky = false;
    }
  };

  let rafId = null;
  const onScroll = () => {
    if (rafId === null) {
      rafId = requestAnimationFrame(() => {
        updateSticky();
        updateActiveSection();
        rafId = null;
      });
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });

  let tocResizeTimeout;
  window.addEventListener(
    'resize',
    () => {
      clearTimeout(tocResizeTimeout);
      tocResizeTimeout = setTimeout(() => {
        if (!isSticky) {
          sidebarTop = sectionBottom = 0;
        }
        updateSticky();
        updateActiveSection();
      }, RESIZE_DELAY);
    },
    { passive: true },
  );

  setTimeout(() => {
    updateSticky();
    updateActiveSection();
  }, INIT_DELAY);
}

const SupportedCountriesModal = (function () {
  let payoneer = [];
  let wise = [];
  let revolut = [];

  function loadData() {
    const popup = document.getElementById('countriesPopup');
    if (!popup) return false;
    try {
      const data = JSON.parse(popup.getAttribute('data-countries') || '{}');
      payoneer = data.payoneer || [];
      wise = data.wise || [];
      revolut = data.revolut || [];
      return true;
    } catch (e) {
      console.error('Failed to load countries data:', e);
      return false;
    }
  }

  function buildTable(filter = '') {
    const q = filter.trim().toLowerCase();
    const tbody = document.getElementById('countriesBody');
    const noResults = document.getElementById('noResults');
    if (!tbody || !noResults) return;

    const filterList = (list) => (q ? list.filter((c) => c.toLowerCase().includes(q)) : list);
    const fp = filterList(payoneer);
    const fw = filterList(wise);
    const fr = filterList(revolut);

    ['payoneer', 'wise', 'revolut'].forEach((id, i) => {
      const el = document.getElementById(id + 'Count');
      if (el) el.textContent = [fp, fw, fr][i].length;
    });

    const rows = Math.max(fp.length, fw.length, fr.length);
    if (rows === 0) {
      tbody.innerHTML = '';
      noResults.classList.add('visible');
      return;
    }
    noResults.classList.remove('visible');

    const highlight = (text) => {
      if (!q) return text;
      const idx = text.toLowerCase().indexOf(q);
      if (idx === -1) return text;
      return text.slice(0, idx) + '<mark>' + text.slice(idx, idx + q.length) + '</mark>' + text.slice(idx + q.length);
    };

    tbody.innerHTML = Array.from(
      { length: rows },
      (_, i) =>
        `<tr>
        <td>${fp[i] ? highlight(fp[i]) : ''}</td>
        <td>${fw[i] ? highlight(fw[i]) : ''}</td>
        <td>${fr[i] ? highlight(fr[i]) : ''}</td>
      </tr>`,
    ).join('');
  }

  function filterTable() {
    const searchInput = document.getElementById('countrySearch');
    if (searchInput) buildTable(searchInput.value);
  }

  function openPopup() {
    const popup = document.getElementById('countriesPopup');
    const searchInput = document.getElementById('countrySearch');
    const scrollWrap = document.getElementById('tableScrollWrap');
    if (searchInput) searchInput.value = '';
    buildTable();
    if (popup) popup.classList.add('is-open');
    if (scrollWrap) scrollWrap.scrollTop = 0;
    setTimeout(() => {
      if (searchInput) searchInput.focus();
    }, 50);
  }

  function closePopup() {
    const popup = document.getElementById('countriesPopup');
    if (popup) popup.classList.remove('is-open');
  }

  function init() {
    if (!loadData()) {
      console.warn('Supported countries data not found');
      return;
    }

    const searchInput = document.getElementById('countrySearch');
    if (searchInput) searchInput.addEventListener('input', filterTable);

    const popup = document.getElementById('countriesPopup');
    if (popup)
      popup.addEventListener('click', (e) => {
        if (e.target === popup) closePopup();
      });

    document.querySelectorAll('.popup-modal__close, .popup-modal__footer .btn-close').forEach((btn) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        closePopup();
      });
    });

    document.addEventListener('keydown', (e) => {
      const p = document.getElementById('countriesPopup');
      if (e.key === 'Escape' && p && p.classList.contains('is-open')) closePopup();
    });

    document.querySelectorAll('[data-countries-popup-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        openPopup();
      });
    });
  }

  return { init, open: openPopup, close: closePopup };
})();

/* Sustainability projects carousel with looping */
(function () {
  const track = document.querySelector('[data-sy-track]');
  if (!track) return;
  const prev = document.querySelector('[data-sy-prev]');
  const next = document.querySelector('[data-sy-next]');

  function step() {
    const card = track.querySelector('.sy-project');
    if (!card) return track.clientWidth;
    const gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 0) || 0;
    return (card.getBoundingClientRect().width + gap) * 3;
  }

  if (prev)
    prev.addEventListener('click', function () {
      const currentScroll = track.scrollLeft;
      if (currentScroll <= 0) {
        track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      }
    });

  if (next)
    next.addEventListener('click', function () {
      const currentScroll = track.scrollLeft;
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (currentScroll >= maxScroll - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      }
    });
})();

/* Corporate Volunteering blog carousel with looping */
(function () {
  const track = document.querySelector('[data-cv-track]');
  if (!track) return;
  const prev = document.querySelector('[data-cv-prev]');
  const next = document.querySelector('[data-cv-next]');

  function step() {
    const card = track.querySelector('.cv-blog__card');
    if (!card) return track.clientWidth;
    const list = track.querySelector('.cv-blog__track') || track;
    const gap = parseFloat(getComputedStyle(list).columnGap || getComputedStyle(list).gap || 0) || 0;
    const stride = card.getBoundingClientRect().width + gap;
    // Move a whole "page" at a time (the number of cards currently visible).
    const perView = Math.max(1, Math.round(track.clientWidth / stride));
    return stride * perView;
  }

  if (prev)
    prev.addEventListener('click', function () {
      if (track.scrollLeft <= 0) {
        track.scrollTo({ left: track.scrollWidth - track.clientWidth, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: -step(), behavior: 'smooth' });
      }
    });

  if (next)
    next.addEventListener('click', function () {
      const maxScroll = track.scrollWidth - track.clientWidth;
      if (track.scrollLeft >= maxScroll - 10) {
        track.scrollTo({ left: 0, behavior: 'smooth' });
      } else {
        track.scrollBy({ left: step(), behavior: 'smooth' });
      }
    });
})();

/* Gentle parallax on sustainability certified panel photos */
(function () {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  const els = [].slice.call(document.querySelectorAll('[data-sy-parallax]'));
  if (!els.length || reduce.matches) return;
  let ticking = false;
  function update() {
    const vh = window.innerHeight;
    const rects = [];
    for (let i = 0; i < els.length; i++) rects[i] = els[i].getBoundingClientRect();
    for (let j = 0; j < els.length; j++) {
      const el = els[j];
      const r = rects[j];
      if (r.bottom < -100 || r.top > vh + 100) continue;
      const amp = parseFloat(el.getAttribute('data-sy-parallax')) || 24;
      const center = r.top + r.height / 2;
      let prog = (center - vh / 2) / (vh / 2 + r.height / 2);
      if (prog > 1) prog = 1;
      else if (prog < -1) prog = -1;
      el.style.transform = 'translate3d(' + (-prog * amp).toFixed(2) + 'px, 0, 0)';
    }
    ticking = false;
  }
  function onScroll() {
    if (!ticking) {
      ticking = true;
      window.requestAnimationFrame(update);
    }
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* Package recommendation (compare-packages): questions unlock one at a time; shows one of eight result boxes once all three yes/no questions are answered */
document.querySelectorAll('.package-recommendation').forEach(function (widget) {
  const questions = widget.querySelectorAll('[role="radiogroup"]');
  const results = widget.querySelectorAll('[data-answers]');

  function getAnswers() {
    const answers = [];

    questions.forEach(function (question) {
      const checked = question.querySelector('input[type="radio"]:checked');
      if (checked) answers.push(checked.value);
    });

    return answers.length === questions.length ? answers.join('-') : null;
  }

  // Questions must be answered in order: each one unlocks once the previous is answered
  function updateLocks() {
    let unlocked = true;

    questions.forEach(function (question) {
      const inputs = question.querySelectorAll('input[type="radio"]');

      question.setAttribute('aria-disabled', String(!unlocked));
      inputs.forEach(function (input) {
        input.disabled = !unlocked;
        if (!unlocked) input.checked = false;
      });

      if (!question.querySelector('input[type="radio"]:checked')) unlocked = false;
    });
  }

  function updateResult() {
    updateLocks();

    const answers = getAnswers();

    results.forEach(function (result) {
      result.hidden = result.dataset.answers !== answers;
    });
  }

  widget.addEventListener('change', function (e) {
    if (e.target.matches('input[type="radio"]')) updateResult();
  });

  // Restore a result if the browser kept the selected answers (e.g. back navigation)
  updateResult();
});

/* Banks ticker: pause each row while it is being touched */
document.querySelectorAll('.banks-feature__row').forEach(function (row) {
  function pause() {
    row.classList.add('is-paused');
  }

  function resume() {
    row.classList.remove('is-paused');
  }

  row.addEventListener('touchstart', pause, { passive: true });
  row.addEventListener('touchend', resume);
  row.addEventListener('touchcancel', resume);
});
